import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';

Vue.use(Vuex);
Vue.use(VueCookies);

export const store = new Vuex.Store({ // eslint-disable-line
  state: {
    backTo: '',
    scrollToBottom: null,
    showCookiePanel: false,
    showBannerOnClose: true,
    cookiesAccepted: false,
  },
  getters: {
    backTo: state => state.backTo,
    scrollToBottom: state => state.scrollToBottom,
    showCookiePanel: state => state.showCookiePanel,
    showBannerOnClose: state => state.showBannerOnClose,
    cookiesAccepted: state => state.cookiesAccepted,
  },
  mutations: {
    updateBackTo: (state, payload) => {
      state.backTo = payload;
    },
    updateScrollToBottom: (state, payload) => {
      state.scrollToBottom = payload;
    },
    updateShowBannerOnClose: (state, payload) => {
      state.showBannerOnClose = payload;
    },
    updateShowCookiePanel: (state, payload) => {
      VueCookies.set('rareWebSiteAcceptCookies', payload, -1);
      state.showCookiePanel = payload;
    },
    updateCookiesAccepted: (state, payload) => {
      state.cookiesAccepted = payload;
    },
  },
  actions: {},
});



// WEBPACK FOOTER //
// ./src/store/store.js